import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTopicAndProductTags } from '@/utils/dataFormat';
import { changeKeyword, changePage, changeProductSelected, changeSortBy, changeTopicSelected } from '@/store/slices/sortFilterSlice';

export const resetSortFilter = createAsyncThunk(
  'sortFilter/resetSortFilter',
  async ({ tags, keyword }: any, { dispatch, getState }) => {
    const { categoryPage } = getState() as any;
    const { cateTags, productTags } = categoryPage;
    
    const [filterCateTags, filterProductTags] = getTopicAndProductTags(tags, cateTags, productTags);
  
    dispatch(changePage(1));
    dispatch(changeTopicSelected(filterCateTags));
    dispatch(changeProductSelected(filterProductTags));
    dispatch(changeSortBy('publishDate'));
    if (keyword) {
      dispatch(changeKeyword(keyword));
    }
    
    return [filterCateTags, filterProductTags];
  }
);

